import { buildJpegPdf, readJpegSize } from 'shared-models/browser';
export { buildJpegPdf, readJpegSize } from 'shared-models/browser';

export const dataUrlToBytes = (dataUrl: string): Uint8Array => {
  const binary = atob(dataUrl.slice(dataUrl.indexOf(',') + 1));
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
};

export const downloadPdfFile = (pdf: Uint8Array, filename: string): void => {
  // Copied out of the view so the Blob gets a plain ArrayBuffer, never a SharedArrayBuffer.
  const buffer = new ArrayBuffer(pdf.byteLength);
  new Uint8Array(buffer).set(pdf);
  const blob = new Blob([buffer], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
};

const receiptPdf = (jpegDataUrl: string): Uint8Array | null => {
  const image = dataUrlToBytes(jpegDataUrl);
  const size = readJpegSize(image);
  return size ? buildJpegPdf(image, size.width, size.height) : null;
};

export const downloadSummaryReceiptPdf = (jpegDataUrl: string, title: string): boolean => {
  const pdf = receiptPdf(jpegDataUrl);
  if (!pdf) {
    return false;
  }
  downloadPdfFile(pdf, `${title}.pdf`);
  return true;
};
